import { useErrorHandler } from '@shared/errors';
import { useMutation } from '@tanstack/react-query';

import { User } from '@/features/admin/types/user';
import { useClientService } from '@/features/clients/api/use-clients-service';
import { notifySuccess } from '@/lib/notification/notifications';

export const useResetPassword = () => {
  const { resetClientUserPassword } = useClientService();
  const { handleError } = useErrorHandler();

  return useMutation({
    mutationFn: ({ clientId, user }: { clientId: number, user: User }) => resetClientUserPassword(clientId, user.id),
    onSuccess: () => {
      notifySuccess({
        title: 'Success',
        message: 'Password reset email sent.',
      });
    },
    onError: (error) => {
      handleError(error, { title: 'Failure', message: 'Unable to reset password.' });
    }
  });
};
